import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=4426704c&scoped=true"
import script from "./GroupCard.vue?vue&type=script&lang=js"
export * from "./GroupCard.vue?vue&type=script&lang=js"
import style0 from "./GroupCard.vue?vue&type=style&index=0&id=4426704c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4426704c",
  null
  
)

export default component.exports